import { FC } from 'react';
import { handleErrorAvatar } from 'utils/general';
import { GroupAvatar, ImageContainer } from './styled';

interface AvatarProps {
  name?: string;
  src?: string;
  alt?: string;
  size?: number;
}

const Avatar: FC<AvatarProps> = ({
  name,
  src = '/images/avatar.png',
  alt,
  size = 40,
  children,
}) =>
  children ? (
    <GroupAvatar>{children}</GroupAvatar>
  ) : (
    <ImageContainer
      src={src}
      alt={src ? alt : 'User Not Found Avatar'}
      width={size}
      height={size}
      onError={(e) => handleErrorAvatar(e, name)}
    />
  );

export default Avatar;
